import { MediaUploadErrorKey } from "./../ricos-content/index.js";
import { MediaManagerUploadErrorTypes } from "./request-service-provider/upload-types.js";
const getUploadError = (error, metaSiteId, isOwner) => {
  const upgradeUrl = `https://www.wix.com/store/plans?siteGuid=${metaSiteId}`;
  const { key, args } = error.error_info || {};
  const errorMessages = {
    [MediaManagerUploadErrorTypes.SizeLimitExceeded]: {
      key: MediaUploadErrorKey.SIZE_LIMIT,
      args: { maxLimit: parseInt(args?.[1], 10) }
    },
    [MediaManagerUploadErrorTypes.SiteQuotaExceeded]: {
      key: isOwner ? MediaUploadErrorKey.QUOTA_STORAGE_OWNER : MediaUploadErrorKey.QUOTA_STORAGE_VISITOR,
      args: { upgradeUrl, usage: args?.[0], limit: args?.[1] }
    },
    [MediaManagerUploadErrorTypes.SiteVideoDurationQuotaExceeded]: {
      key: isOwner ? MediaUploadErrorKey.QUOTA_VIDEO_OWNER : MediaUploadErrorKey.QUOTA_VIDEO_VISITOR,
      args: { upgradeUrl, usage: args?.[0], limit: args?.[1] }
    },
    [MediaManagerUploadErrorTypes.SiteSingleVideoDurationQuotaExceeded]: {
      key: isOwner ? MediaUploadErrorKey.QUOTA_SINGLE_VIDEO_OWNER : MediaUploadErrorKey.QUOTA_SINGLE_VIDEO_VISITOR,
      args: { upgradeUrl, usage: args?.[0], limit: args?.[1] }
    },
    [MediaManagerUploadErrorTypes.General]: {
      key: MediaUploadErrorKey.GENERIC
    },
    [MediaManagerUploadErrorTypes.MimeTypeMismatch]: {
      key: MediaUploadErrorKey.MIME_TYPE_MISMATCH
    },
    [MediaManagerUploadErrorTypes.InvalidSession]: {
      key: MediaUploadErrorKey.INVALID_SESSION
    },
    [MediaManagerUploadErrorTypes.SessionExpired]: {
      key: MediaUploadErrorKey.SESSION_EXPIRED
    },
    [MediaManagerUploadErrorTypes.MissingWixSession]: {
      key: MediaUploadErrorKey.MISSING_WIX_SESSION
    },
    [MediaManagerUploadErrorTypes.IncorrectFileInfo]: {
      key: MediaUploadErrorKey.INCORRECT_FILE_INFO
    },
    [MediaManagerUploadErrorTypes.InvalidFile]: {
      key: MediaUploadErrorKey.CORRUPT_FILE
    },
    [MediaManagerUploadErrorTypes.UnsupportedFileExtension]: {
      key: MediaUploadErrorKey.UNSUPPORTED_EXTENSION,
      args: { extension: args?.[0] }
    },
    [MediaManagerUploadErrorTypes.WavInvalidMissingHeader]: {
      key: MediaUploadErrorKey.MISSING_HEADER
    },
    [MediaManagerUploadErrorTypes.WavInvalidFormatChunkMissing]: {
      key: MediaUploadErrorKey.FORMAT_CHUNK_MISSING
    },
    [MediaManagerUploadErrorTypes.ExternalFileAuthorization]: {
      key: MediaUploadErrorKey.EXT_FILE_AUTHORIZATION
    },
    [MediaManagerUploadErrorTypes.ExternalFileForbidden]: {
      key: MediaUploadErrorKey.EXT_FILE_FORBBIDEN
    },
    [MediaManagerUploadErrorTypes.UnsupportedImageFormat]: {
      key: MediaUploadErrorKey.IMAGE_FORMAT
    },
    [MediaManagerUploadErrorTypes.CorruptedImage]: {
      key: MediaUploadErrorKey.CORRUPT_IMAGE
    },
    [MediaManagerUploadErrorTypes.ImageDimentionsExceededLimit]: {
      key: MediaUploadErrorKey.IMAGE_DIMENSIONS_EXCEEDED
    },
    [MediaManagerUploadErrorTypes.Mp4UnsupportedStereoOnly]: {
      key: MediaUploadErrorKey.MP4_STEREO_FORMAT
    },
    [MediaManagerUploadErrorTypes.WavUnsupportedStereoOnly]: {
      key: MediaUploadErrorKey.WAV_STEREO_FORMAT
    },
    [MediaManagerUploadErrorTypes.WmaUnsupportedBitrate]: {
      key: MediaUploadErrorKey.WMA_BITRATE
    },
    [MediaManagerUploadErrorTypes.WmaUnsupportedBitrateLossy]: {
      key: MediaUploadErrorKey.WMA_BITRATE_LOSSY
    },
    [MediaManagerUploadErrorTypes.Mp4UnsupportedBitrate]: {
      key: MediaUploadErrorKey.MP4_BITRATE
    },
    [MediaManagerUploadErrorTypes.Mp3UnsupportedStereoOnly]: {
      key: MediaUploadErrorKey.MP3_UNSUPPORTED_STEREO
    },
    [MediaManagerUploadErrorTypes.Mp3UnsupportedFormat]: {
      key: MediaUploadErrorKey.MP3_UNSUPPORTED_FORMAT
    },
    [MediaManagerUploadErrorTypes.WavUnsupportedSampleRate]: {
      key: MediaUploadErrorKey.WAV_SAMPLE_RATE
    },
    [MediaManagerUploadErrorTypes.AacUnsupportedFormat]: {
      key: MediaUploadErrorKey.AAC_UNSUPPORTED_FORMAT
    },
    [MediaManagerUploadErrorTypes.WavUnsupportedFormat]: {
      key: MediaUploadErrorKey.WAV_UNSUPPORTED_FORMAT
    },
    [MediaManagerUploadErrorTypes.WavUnsupportedSampleSize]: {
      key: MediaUploadErrorKey.WAV_SAMPLE_SIZE
    },
    [MediaManagerUploadErrorTypes.WavUnsupportedFormatChunkSize]: {
      key: MediaUploadErrorKey.WAV_CHUNK_SIZE
    },
    [MediaManagerUploadErrorTypes.UnsupportedAudioCodec]: {
      key: MediaUploadErrorKey.AUDIO_CODEC,
      args: { codec: args?.[0] }
    },
    [MediaManagerUploadErrorTypes.ZeroSizeFile]: {
      key: MediaUploadErrorKey.EMPTY_FILE
    },
    [MediaManagerUploadErrorTypes.Mp4UnsupportedFormat]: {
      key: MediaUploadErrorKey.MP4_UNSUPPORTED_FORMAT
    },
    [MediaManagerUploadErrorTypes.Mp4UnsupportedSampleRate]: {
      key: MediaUploadErrorKey.MP4_SAMPLE_RATE
    },
    [MediaManagerUploadErrorTypes.MaxVideoBitrateIsExceeded]: {
      key: MediaUploadErrorKey.VIDEO_BITRATE,
      args: { fps: args?.[0] }
    },
    [MediaManagerUploadErrorTypes.VideoDurationMismatch]: {
      key: MediaUploadErrorKey.VIDEO_DURATION_MISMATCH,
      args: { videoDuration: args?.[0], audioDuration: args?.[1] }
    },
    [MediaManagerUploadErrorTypes.UnsupportedVideoCodec]: {
      key: MediaUploadErrorKey.VIDEO_CODEC,
      args: { codec: args?.[0] }
    }
  };
  const uploadError = errorMessages[key];
  return { msg: error.error_description, ...uploadError };
};
export {
  getUploadError
};
//# sourceMappingURL=get-upload-error.js.map
